import React, { PropsWithChildren } from "react";
import cx from "classnames";
import PerfectScrollbar from "react-perfect-scrollbar";

import styles from "./index.module.scss";

interface Props {
  className?: string;
  // style?: any;
  [key: string]: any;
}

const XtScrollBarY: React.FC<PropsWithChildren<Props>> = (({ children, className, ...rest }) => {
  return (
    <div className={cx(styles.main, className)}>
      <PerfectScrollbar options={{ suppressScrollX: true }} {...rest}>
        {children}
      </PerfectScrollbar>
    </div>
  );
});

// XtScrollBarY.displayName = 'XtScrollBarY';

export default XtScrollBarY;
